
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const PresidentPage = lazy(() => import('../pages/president/page'));
const ProgramsPage = lazy(() => import('../pages/programs/page'));
const BusinessEmpowermentPage = lazy(() => import('../pages/programs/business-empowerment/page'));
const EducationReorientationPage = lazy(() => import('../pages/programs/education-reorientation/page'));
const CommunityDevelopmentPage = lazy(() => import('../pages/programs/community-development/page'));
const NetworkingAdvocacyPage = lazy(() => import('../pages/programs/networking-advocacy/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const PartnershipPage = lazy(() => import('../pages/partnership/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/president',
    element: <PresidentPage />,
  },
  {
    path: '/programs',
    element: <ProgramsPage />,
  },
  {
    path: '/programs/business-empowerment',
    element: <BusinessEmpowermentPage />,
  },
  {
    path: '/programs/education-reorientation',
    element: <EducationReorientationPage />,
  },
  {
    path: '/programs/community-development',
    element: <CommunityDevelopmentPage />,
  },
  {
    path: '/programs/networking-advocacy',
    element: <NetworkingAdvocacyPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/partnership',
    element: <PartnershipPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
